/* Quote request page: renders the list built on product pages and folds it into the
 * contact form's message body on submit. */
(() => {
  const root = document.querySelector("[data-bd-quote]");
  if (!root) return;
  const $ = (s) => root.querySelector(s);

  const KEY = "blankd:quote:v1";
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const save = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch {} };

  function paint() {
    const list = load();
    const rows = $("[data-q-rows]");
    const empty = $("[data-q-empty]");
    const tot = $("[data-q-total]");

    empty.hidden = list.length > 0;
    tot.hidden = list.length === 0;

    rows.innerHTML = list.map((l, i) => {
      const sizeKey = Object.keys(l.sizes || {})[0] || "";
      const qty = l.sizes?.[sizeKey] ?? l.total ?? 0;
      return `
      <div class="bd-qrow">
        <div class="bd-qrow__im">${l.image ? `<img src="${esc(l.image)}" alt="" loading="lazy">` : ""}</div>
        <div class="bd-qrow__info">
          <span class="bd-qrow__t">${esc(l.title)}</span>
          <span class="bd-qrow__m">${esc(l.colour)} · ${esc(l.method)}${l.delivery ? ` · ${esc(l.delivery)}` : ""}${sizeKey ? ` · SIZE ${esc(sizeKey)}` : ""}</span>
        </div>
        <input type="number" class="bd-qrow__qty" min="1" value="${qty}" data-q-qty="${i}" aria-label="Quantity for ${esc(l.title)}">
        <button type="button" class="bd-qrow__x" data-q-remove="${i}" aria-label="Remove ${esc(l.title)}">&times;</button>
      </div>`;
    }).join("");

    const pieces = list.reduce((a, l) => a + l.total, 0);
    tot.textContent = `${list.length} line${list.length === 1 ? "" : "s"} · ${pieces} piece${pieces === 1 ? "" : "s"} in total`;

    // Keep the hidden body in step, so a submit at any moment carries the current list.
    const body = $("[data-q-body]");
    if (body) body.value = compose(list);
  }

  // The list is untrusted only in the sense that it is the customer's own input; it still
  // goes into an HTML string here, so escape it.
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  function compose(list) {
    if (!list.length) return "Quote request with an empty list.";
    const lines = list.map((l, i) => `${i + 1}. ${l.title} — ${l.colour} — ${l.method}${l.delivery ? ` — ${l.delivery}` : ""} — ${l.sizeText} (${l.total} pcs)`);
    const pieces = list.reduce((a, l) => a + l.total, 0);
    return `QUOTE REQUEST\n\n${lines.join("\n")}\n\nTotal: ${pieces} pieces across ${list.length} line(s).`;
  }

  root.addEventListener("click", (e) => {
    const i = e.target.dataset?.qRemove;
    if (i == null) return;
    const list = load();
    list.splice(+i, 1);
    save(list);
    paint();
  });

  // Editing a size's qty updates that one size, sizeText and total together, so the emailed
  // request always matches the number on screen — never a stale sizeText from add-to-quote.
  root.addEventListener("change", (e) => {
    const i = e.target.dataset?.qQty;
    if (i == null) return;
    const list = load();
    const line = list[+i];
    if (!line) return;
    const sizeKey = Object.keys(line.sizes || {})[0] || "";
    const qty = Math.max(1, parseInt(e.target.value, 10) || 1);
    line.sizes = { [sizeKey]: qty };
    line.sizeText = sizeKey ? `${qty} × ${sizeKey}` : String(qty);
    line.total = qty;
    save(list);
    paint();
  });

  // Fold the extra fields into the body too — Shopify only emails known contact[] keys
  // reliably, and the body is the one field that always comes through intact.
  const form = document.getElementById("quote-form");
  form?.addEventListener("submit", () => {
    const get = (n) => form.querySelector(`[name="contact[${n}]"]`)?.value?.trim();
    const extra = [
      get("company") && `Company: ${get("company")}`,
      get("needed_by") && `Needed by: ${get("needed_by")}`,
      get("brief") && `\nBrief:\n${get("brief")}`,
    ].filter(Boolean).join("\n");
    const body = $("[data-q-body]");
    if (body) body.value = compose(load()) + (extra ? `\n\n${extra}` : "");
    // Deliberately NOT cleared here: the dropzone (blankd-upload.js) can still fail and
    // preventDefault this same submit to retry, and clearing early would lose the list under
    // the customer with nothing actually sent. Cleared instead once Shopify confirms the
    // request landed — see the data-bd-quote-posted check below.
  });

  if ($("[data-quote-posted]")?.dataset.quotePosted === "true") save([]);

  paint();
})();
